import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const checkEmailQuery = graphql(/* GraphQL */ `
    query CheckEmail($formFields: checkEmailFormFields!) {
        checkEmail(formFields: $formFields) {
            success
        }
    }
`);
